<template>
  <AuthLayout tab="register">
    <RegisterForm/>
  </AuthLayout>
</template>
<script>
    import RegisterForm from "../components/forms/RegisterForm.vue";
    import AuthLayout from "@/components/public/AuthLayout.vue";
    import {useHead} from "@vueuse/head";

    export default {
        name: 'RegisterView',
        components: {
            RegisterForm,
            AuthLayout,
        },
      mounted() {
        useHead({
          title: 'Inscription - Logiciel de facturation électronique français sécurisé',
          meta: [
            {
              name: 'robots',
              content: 'noindex, nofollow'
            }
          ]
        });
      }
    }
</script>
